<template>
  <gmap
    @mapReady="handleMapReady"
    containerHeight="100%"
    height="100%"
    :center="mapCenter"
    :addMarkerToCenter="addMarkerToCenter"
    :markerOptions="{
      optimized: false,
    }"
    :markerIconOptions="currentLocationMarkerIcon"
    :zoom="16"
  />
</template>

<script>
import mapsmixin from "../mixins/mapsmixin";
import Gmap from "../components/Map";

export default {
  mixins: [mapsmixin],

  components: {
    gmap: Gmap,
  },

  props: {
    plants: Array,
    is_limited_member: Boolean,
  },

  data() {
    return {
      addMarkerToCenter: false,
      currentLocationCoords: {},
      currentLocationMarkerIcon: {
        url: this.getMarkerIcon(true),
        size: 30,
      },
      mapCenter: null,
      mapCenterReady: false,
      mapZoomLevel: 16,
    };
  },

  computed: {
    viewReady() {
      return this.mapReady && this.mapCenterReady;
    },
  },

  methods: {
    doGeolocation() {
      this.currentLocationCoords = {
        lat: this.plants[0].latitude,
        lng: this.plants[0].longitude,
      };
    },
    addPlantsToMap() {
      let vm = this;

      let prefix = vm.$prefix;

      let infowindow = new vm.google.maps.InfoWindow();

      vm.spiderfier = new OverlappingMarkerSpiderfier(vm.map, vm.spiderfierOptions);
      vm.markers = vm.plants.map((plant) => {
        let marker = new vm.google.maps.Marker({
          icon: {
            url: vm.getMarkerIcon(),
            anchor: new vm.google.maps.Point(10, 10),
            scaledSize: new vm.google.maps.Size(20, 20),
          },
          plantData: {
            id: plant.id,
            nickname: plant.plant_nickname ?? "",
            plant: plant.common_name ? plant.common_name : plant.scientific_name,
            url: `/my-plants/${plant.id}`,
          },
          position: new vm.google.maps.LatLng(
            parseFloat(plant.latitude),
            parseFloat(plant.longitude)
          ),
        });

        vm.spiderfier.trackMarker(marker);
        vm.google.maps.event.addListener(marker, "spider_click", function () {
          infowindow.close();
          infowindow.setContent(`
            <div class="w-48 p-2">
              <p class="font-normal text-gray-400 uppercase text-xxs">${vm.trans.get(
                "strings.plants.plant_nickname"
              )}</p>
              <p class="mt-2 font-medium uppercase text-xxs">${
                marker.plantData.nickname
              }</p>
              <p class="mt-2 text-base font-medium capitalize">${
                marker.plantData.plant
              }</p>
              <a class="flex items-center mt-6 font-normal" href="${prefix}${marker.plantData.url}">
                <span class="mr-2 text-base text-green-800 bb-leaf"></span>
                <span>${vm.trans.get("strings.plants.view_plant")}</span>
              </a>
              ${
                plant.plant_nickname && !vm.is_limited_member
                  ? `<a class="flex items-center mt-2 font-normal" href="${prefix}/observations/create/${
                      plant.id
                    }">
                <span class="mr-2 text-base text-green-800 bb-camera-stroke"></span>
                <span>${vm.trans.get("strings.plants.start_observation")}</span>
              </a>`
                  : ""
              }
            </div>
          `);
          infowindow.open(vm.map, marker);
        });

        return marker;
      });

      setTimeout(() => {
        vm.clusterer = new MarkerClusterer(vm.map, vm.markers, vm.clustererOptions);
      }, 300);
    },
    panMapToLocation(latitude, longitude, plant_id) {
      if (this.map) {
        if (latitude && longitude) {
          this.map.panTo(new this.google.maps.LatLng(latitude, longitude));
        }

        this.map.setZoom(this.mapZoomLevel);

        let current_marker_index = _.findIndex(this.markers, function (marker) {
          return marker.plantData.id == plant_id;
        });

        if (current_marker_index > -1) {
          this.google.maps.event.trigger(
            this.markers[current_marker_index],
            "spider_click",
            {}
          );
        }
      }
    },
  },

  watch: {
    currentLocationCoords(value) {
      if (this.plants.length !== 0) {
        let plant = this.plants[0];

        this.mapCenter = {
          lat: parseFloat(plant.latitude),
          lng: parseFloat(plant.longitude),
        };
      } else {
        this.addMarkerToCenter = true;
        this.mapCenter = value;
      }

      this.mapCenterReady = true;
    },
    map(value) {
      this.doGeolocation();
      this.map.setOptions({
        zoomControlOptions: {
          position: this.google.maps.ControlPosition.TOP_RIGHT,
        },
      });
    },
    viewReady(value) {
      if (value) {
        this.addPlantsToMap();
        this.$emit("mapLoaded");
      }
    },
  },
};
</script>
